<template>
  <div class="left-chart-1">
    <div class="lc1-header">总体进度</div>
    <div class="lc1-details">总场数<span>{{ all.scene }}</span>总人数<span>{{  all.attendance }}</span></div>
    <dv-decoration-2 style="height:10px;" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LayoutLeft',
  data () {
    return {
      all: {
        scene: 100,
        attendance: 10000,
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
        loadList() {
            var that = this;
            axios.get(this.$store.state.config.host + "/big/all/")
            .then(response => {
                that.all = response.data.data;
            })
        },
  }
}
</script>

<style lang="less">
.left-chart-1 {
  width: 100%;
  height: 12%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;

  .lc1-header {
    text-align: center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    margin-bottom: 20px;
  }

  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 22px;
    }
  }

  .lc1-chart {
    flex: 1;
  }
}
</style>

